import { isScreeningVideoUrl } from '../../data/screening-results.adapter';
import { FlaggedCohortContent } from '../../data/screening-results.model';

/** First playable file on the post, when the cohort sent one. */
export function flaggedMediaUrl(post: FlaggedCohortContent): string | undefined {
  return post.item.contentUrls[0] ?? post.item.contentUrl;
}

export function flaggedMediaIsVideo(url: string | undefined): boolean {
  return !!url && isScreeningVideoUrl(url);
}

export function flaggedPositionLabel(post: FlaggedCohortContent): string {
  return `${post.contentIndex} of ${post.contentTotal}`;
}

export function flaggedWatchLabel(creatorName: string): string {
  return `Watch ${creatorName}'s content`;
}

export function flaggedDecisionLabel(action: 'Reject' | 'Override', creatorName: string): string {
  if (action === 'Override') {
    return `Override ${creatorName}'s content`;
  }
  return `${action} ${creatorName}'s content. Decision is not connected yet`;
}

export function flaggedIssueLabel(count: number): string {
  return count === 1 ? '1 issue found' : `${count} issues found`;
}
